import { render } from "./NewsBlock.vue?vue&type=template&id=2d3c773d&scoped=true"
import script from "./NewsBlock.vue?vue&type=script&lang=js"
export * from "./NewsBlock.vue?vue&type=script&lang=js"

import "./NewsBlock.vue?vue&type=style&index=0&id=2d3c773d&scoped=true&lang=css"

import exportComponent from "D:\\GitHub\\KirillSuprunJob.github.io\\Portfolio\\AlbumPortfolio\\InfoWebPage\\info_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3c773d"]])

export default __exports__